import React from 'react';
import { MagnifyingGlassIcon } from '@phosphor-icons/react';
import { Input } from 'shared-ui';

// Callers size the field with className, so it goes on the outer container and the box stretches to fill it.
const fillContainer = { style: { flex: 1, minHeight: 0 } };

export default function SearchInput({ className, ...props }: React.InputHTMLAttributes<HTMLInputElement>): JSX.Element {
    return (
        <Input
            prefix={<MagnifyingGlassIcon size={16} />}
            containerProps={{ className }}
            boxProps={fillContainer}
            {...props}
        />
    );
}
